module.exports = __webpack_public_path__ + "media/src/images/icons/linkexpired_icon-a5aa7ba3d6c18f9743efc58db978816d.svg";